@if(fromActionButton) {
<label for="document">
    <strong>Add New Document</strong>
    <i class="pi pi-info-circle p-ml-1 info-icon" [pTooltip]="tooltipText" showDelay="100"
        tooltipStyleClass="info-tooltip"></i>
</label>
<p-messages [(value)]="maxFilesizeErrorMessage" [enableService]="false" [closable]="false"></p-messages>
                <p-messages [(value)]="maxNoOfFilesErrorMessage" [enableService]="false"
                    [closable]="false"></p-messages>
                <p-messages [(value)]="specialCharacterErrorMsg" [enableService]="false"
                    [closable]="false"></p-messages>
<p-fileUpload multiple="multiple" [maxFileSize]="262144001" [files]="files" [auto]="false" customUpload=true url=""
    (onSelect)="uploadAttachments($event.files)" (onClear)="removeAllFiles()" (uploadHandler)="save(fileUploader)"
    name="myfile[]" #fileUploader>
    <ng-template pTemplate="file" let-file>
        <div class="file-info">
            <div>
                <img class="file-icon" [src]="getFileIcon(file.name)" alt="Invalid File">
            </div>
            <div [pTooltip]="file.name" class="truncate">
                {{ file.name }}
            </div>
            <div>
                {{ file.size | fileSize }}
            </div>
            <div>
                <p-button icon="pi pi-times" iconPos="left" class="p-button-danger"
                    (click)="removeFromUpload(file, fileUploader)"></p-button>
            </div>
        </div>
    </ng-template>
</p-fileUpload>
}

<p-table #documentTable [value]="documentsList" [paginator]="true" [rowHover]="true" [rows]="pageSize"
    [loading]="loading" [showCurrentPageReport]="true" [rowsPerPageOptions]="[5,10,25,50]"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
    (onLazyLoad)="getAllDocumentsWithPagination($event)" [totalRecords]="totalRecords" [lazy]="true" [first]="first">
    <ng-template pTemplate="header">
        <tr>
            <th id="name">Document Name</th>
            <th id="uploaded_date">Last Updated On</th>
            <th id="uploaded_by">Uploaded By</th>
            <th class="action" id="action" style="width:8rem">
                @if(selectedData?.statusId !== 2) {
                <span pTooltip="Refresh List" tooltipPosition="bottom" (click)="refreshDocuments()" class="btnBars">
                    <i class="pi pi-refresh p-mr-1"></i>
                </span>
                <span *ngIf="!fromActionButton" pTooltip="Add Document" tooltipPosition="bottom" (click)="addUpload()"
                    class="btnBars">
                    <i class="pi pi-plus p-mr-1"></i>
                </span>
                }
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody" aria-busy="true" role="alert" aria-label="Loading documents">
        <tr *ngFor="let _ of [1]">
            <td>
            </td>
            <td *ngIf="!fromActionButton"></td>
            <td></td>
            <td></td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td class="text-center" colspan="9">No Documents found</td>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-document let-i="rowIndex">
        <tr>
            <td class="p-d-flex p-ai-center">
                <div class="file-tableinfo">
                    <img [src]="getFileIcon(document.name)" [alt]="document.name.split('.').pop()" class="file-icon" />
                    <div>
                        <a target="_blank" rel="noopener noreferrer" (click)="openFilePreview($event,document)"
                        class="truncate pointer" pTooltip="View Document" tooltipPosition="top">
                        {{ document.name }}
                        </a>
                        <div class="light-font"> <strong>Uploaded on {{document?.createdDate | localDate}}</strong></div>
                    </div>
                </div>
            </td>
            <td>{{document?.updatedDate | localDate}}</td>
            <td>{{document.createdBy}}</td>
            <td class="action" style="min-width: 110px;">
                <span *ngIf="selectedData?.statusId !== 2" class="btnBars p-mr-0">
                    <i class="pi pi-pencil" pTooltip="Edit" tooltipPosition="top" (click)="editUpload(document)"></i>
                </span>
                <span *ngIf="selectedData?.statusId !== 2" class="btnBars p-mr-0">
                    <i class="pi pi-trash" pTooltip="Delete" tooltipPosition="top" (click)="delUpload(document)"></i>
                </span>
                <span class="btnBars p-mr-0">
                    <i class="pi pi-download" pTooltip="Download" tooltipPosition="top"
                        (click)="downloadLink(document)"></i>
                </span>
            </td>
        </tr>
    </ng-template>
</p-table>

<!-- Add-Edit Document Dialog -->
<p-dialog [(visible)]="displayNewUpload" [modal]="true" [closable]="false" [style]="{width: '60vw'}">
    <ng-template pTemplate="header">
        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
            <h5>{{ saveBtn == 'edit' ? 'Edit Document' : 'Add New Document' }}</h5>
        </div>
    </ng-template>
    <div class="card">
        <div *ngIf="saveBtn == 'edit'" class="p-grid">
            <div class="p-col-12">
                <label for="name">Document Name</label>
                <input *ngIf="saveBtn == 'edit'" type="text" pInputText [(ngModel)]="tempDuc.name">
            </div>
        </div>
        <div *ngIf="saveBtn == 'upload'" class="p-grid">
            <div class="p-col-12 message-outer">
                <label for="upload" style="display: flex; align-items: center;" class="p-text-bold">
                   Upload &nbsp;
                    <i class="pi pi-info-circle" [pTooltip]="tooltipText" tooltipPosition="right" showDelay="100" tooltipStyleClass="info-tooltip"></i>
                </label>
                <p-messages [(value)]="maxFilesizeErrorMessage" [enableService]="false" [closable]="false"></p-messages>
                <p-messages [(value)]="maxNoOfFilesErrorMessage" [enableService]="false"
                    [closable]="false"></p-messages>
                <p-messages [(value)]="specialCharacterErrorMsg" [enableService]="false"
                    [closable]="false"></p-messages>
                <p-fileUpload multiple="multiple" maxFileSize="262144001" [files]="files" [showUploadButton]="false"
                    (onSelect)="uploadAttachments($event.files)" (onClear)="removeAllFiles()" name="myfile[]"
                    #fileUploader>
                    <ng-template pTemplate="file" let-file>
                        <div class="file-info">
                            <div>
                                <img class="file-icon" [src]="getFileIcon(file.name)" alt="Invalid File">
                            </div>
                            <div [pTooltip]="file.name" class="truncate">
                                {{ file.name }}
                            </div>
                            <div>
                                {{ file.size | fileSize }}
                            </div>
                            <div>
                                <p-button icon="pi pi-times" iconPos="left" class="p-button-danger"
                                    (click)="removeFromUpload(file, fileUploader)"></p-button>
                            </div>
                        </div>
                    </ng-template>
                </p-fileUpload>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayNewUpload=false;newFileList=[];" label="Cancel"
            class="p-button-secondary"></button>
        <button *ngIf="saveBtn == 'edit'" type="submit" pButton label="Save" (click)="editDocument()"></button>
        <button *ngIf="saveBtn == 'upload'" type="submit"
            [disabled]="fileList?.length == 0 || fileList?.length > 3 || totalFileSize > 262144001" pButton label="Save"
            (click)="save(fileUploader)"></button>
    </p-footer>
</p-dialog>

<app-shared-file-opener *ngIf="displayFilePreview" [modalDisplay]="displayFilePreview" [modalFile]="currentFile" [directLink]="true" (closeFilePreview)="closeFilePreview()"></app-shared-file-opener>